import React, { useRef, useEffect } from 'react';
import './Socials.css';
import socialMediaPng from '../../../assets/images/home/social_media_1.png';
import socialMediaWebp from '../../../assets/images/home/social_media_1.webp';

const Socials = () => {
  const textSectionRef = useRef(null);
  const imageSectionRef = useRef(null);
  const linksRef = useRef(null);

  useEffect(() => {
    // Main observer for text and image sections
    const mainObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.17 }
    );

    // Separate observer for social links with higher threshold
    const linksObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-links');
          }
        });
      },
      { 
        threshold: 0.25,
        rootMargin: '-100px 0px' 
      }
    );

    // Observe main sections
    [textSectionRef, imageSectionRef].forEach(ref => {
      if (ref.current) {
        mainObserver.observe(ref.current);
      }
    });

    // Observe links separately
    if (linksRef.current) {
      linksObserver.observe(linksRef.current);
    }

    return () => {
      [textSectionRef, imageSectionRef].forEach(ref => {
        if (ref.current) {
          mainObserver.unobserve(ref.current);
        }
      });
      if (linksRef.current) {
        linksObserver.unobserve(linksRef.current);
      }
    };
  }, []);

  return (
    <div className="socials-container">
      <div className="socials-content">
        <div className="socials-text-section" ref={textSectionRef}>
          <h2 className="socials-heading">Find<span style={{color:'#97c284'}}> PCG</span> on these <span style={{color:'#83cdbc'}}>platforms</span></h2>
          <div className="socials-list" ref={linksRef}>
            <a href="https://discord.com/invite/XuXajDW" style={{"--delay": "0.1s"}}><span><i className="fa-brands fa-discord"></i><p>Discord</p></span></a>
            <a href="https://www.youtube.com/channel/UCW4JLT0B1umnFijn8E7s5ZA" style={{"--delay": "0.2s"}}><span><i className="fa-brands fa-youtube"></i><p>YouTube</p></span></a>
            <a href="https://x.com/PapercactusGame" style={{"--delay": "0.3s"}}><span><i className="fa-brands fa-x-twitter"></i><p>Twitter / X</p></span></a>
            <a href="https://www.instagram.com/PapercactusGames/" style={{"--delay": "0.4s"}}><span><i className="fa-brands fa-instagram"></i><p>Instagram</p></span></a>
          </div>
        </div>
        <div className="socials-image-section" ref={imageSectionRef}>
          <picture>
            <source srcSet={socialMediaWebp} type="image/webp" />
            <source srcSet={socialMediaPng} type="image/png" />
            <img src={socialMediaPng} alt="Social Media" className="socials-image" />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default Socials;